import DestinationAccordion from './DestinationAccordion'

export default DestinationAccordion
